var React = require('react');

function ArrowRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 3.50005L11.2147 2.69942L8.56638 -1.50088e-07L7.78106 0.800536L9.87393 2.93388L-1.28244e-07 2.93388L-1.77736e-07 4.06612L9.8737 4.06612L7.78093 6.19946L8.56624 7L12 3.50005Z","fill":"white"}));
}

ArrowRightInline.defaultProps = {"width":"12","height":"7","viewBox":"0 0 12 7","fill":"none"};

module.exports = ArrowRightInline;

ArrowRightInline.default = ArrowRightInline;
